module.exports = __webpack_public_path__ + "static/Fantastic_Beasts_1920x900-tablet.5c475d5f.png";